import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './SubNavbar.css';

const SubNavbar = () => {
  const location = useLocation();
  
  // Get the current page name from the path
  const getCurrentPage = () => {
    const path = location.pathname;
    switch(path) {
      case '/work':
        return 'Work';
      case '/writings':
        return 'Writings';
      case '/photography':
        return 'Photography';
      case '/books':
        return 'Books';
      default:
        return '';
    }
  };

  // Get the collection name for photography and writings pages
  const getCollectionName = () => {
    const path = location.pathname;
    if (path.startsWith('/photography/')) {
      const collection = path.split('/')[2];
      switch(collection) {
        case 'italy-greece':
          return 'Italy & Greece';
        case 'bay-area':
          return 'Bay Area';
        case 'us-various':
          return 'US (Various)';
        default:
          return collection;
      }
    }
    if (path.startsWith('/writings/')) {
      const collection = path.split('/')[2];
      switch(collection) {
        case 'blog-post-1':
          return 'Blog Post 1';
        case 'blog-post-2':
          return 'Blog Post 2';
        default:
          return collection;
      }
    }
    return '';
  };
  
  const currentPage = getCurrentPage();
  const collectionName = getCollectionName();
  const isPhotographyCollection = location.pathname.startsWith('/photography/') && location.pathname !== '/photography';
  const isWritingsCollection = location.pathname.startsWith('/writings/') && location.pathname !== '/writings';
  
  return (
    <nav className="sub-navbar">
      <div className="nav-breadcrumb">
        <Link to="/" className="nav-name">Hadi Fawad</Link>
        <span className="nav-separator">/</span>
        {isPhotographyCollection ? (
          <>
            <Link to="/photography" className="nav-current">Photography</Link>
            <span className="nav-separator">/</span>
            <Link to={location.pathname} className="nav-current">{collectionName}</Link>
          </>
        ) : isWritingsCollection ? (
          <>
            <Link to="/writings" className="nav-current">Writings</Link>
            <span className="nav-separator">/</span>
            <Link to={location.pathname} className="nav-current">{collectionName}</Link>
          </>
        ) : (
          <Link to={location.pathname} className="nav-current">{currentPage}</Link>
        )}
      </div>
    </nav>
  );
};

export default SubNavbar;
